import { resolveImageURL, isYouTubeUrl} from '../../../helpers/multimediaUtils';  
import PageHeaderBackground from '../../Molecules/PageHeaderBackground';
import {
  ContentNarrow,
  ContentWide,
  ContentWrapper,
  PageSection
} from 'volto-essvoltocomponents/components/Layout';
import { UniversalLink } from '@plone/volto/components';
import YouTubePlayer from '../../Atoms/YouTubePlayer';
import RichText from '../../Atoms/RichText';
import PDFJSViewer from '../../Atoms/PDFJSViewer';

const SimplePageView = ({ content }) => {
  const title = content.title
  const externalUrl = content.url //zope.schema.URI that volto receives as plain string
  const headerImageUrl = content?.inline_image ? resolveImageURL(content, '/@@images/inline_image') : '';
  const heroImageUrl = content?.hero_image ? resolveImageURL(content, '/@@images/hero_image') : '';
  const heroVideoUrl = content.inline_iframe
  const body = content.body?.data  //richtext
  const pdfUrl = content.inline_pdf
  return (
    <>
      <PageHeaderBackground
        title={content?.title || ''}
        details=""
        description={content.full_description?.data || ''}
        backgroundImage={heroImageUrl}
        blurBg = {true}
      />
      <PageSection 
        paddingBottom="var(--ess-space-7xl)"
      >
        {/* External URL */}
        {externalUrl && 
          <ContentWrapper>
            <ContentWide>
              <UniversalLink href={externalUrl} className="multimedia-item-external-url" >
                Website: {externalUrl} 
              </UniversalLink>    
            </ContentWide>
          </ContentWrapper>
        }
        
        {/* Image */}
        {headerImageUrl && 
          <ContentWrapper>
            <ContentWide>
              <img
                src={headerImageUrl}
                alt={title || ''}
                loading="lazy"
                className="multimedia-item-hero-image" 
              />
            </ContentWide>
          </ContentWrapper>
        }

        {/* Video */}
        {heroVideoUrl && 
          <ContentWrapper>
            <ContentWide>
              {(isYouTubeUrl(heroVideoUrl) ? (
                  <YouTubePlayer
                    url={heroVideoUrl}
                    aspectRatio="16/9"
                    className="multimedia-item-hero-video"
                  />
                ) : (
                  <div className="multimedia-item-hero-video">
                    <iframe
                      src={heroVideoUrl}
                      title={title || 'Embedded video'}
                      width="100%"
                      height="480"
                      style={{ border: 0 }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                    />
                  </div>
                )
              )}
            </ContentWide>
          </ContentWrapper>
        }
        
        {/* PDF */}
        {pdfUrl && 
          <ContentWrapper>
            <ContentWide>
              {PDFJSViewer ? (
                  <PDFJSViewer url={pdfUrl}/>
                ) : (
                <div>Loading PDF viewer...</div>
              )}
            </ContentWide>
          </ContentWrapper>
        }

        {/* Body */}
        {body && 
          <ContentWrapper paddingBottom='0'>
            <ContentWide>
              <ContentNarrow>
                <RichText 
                  content={body} 
                  className="multimedia-item-body"/>
              </ContentNarrow>
            </ContentWide>
          </ContentWrapper>
        } 

      </PageSection>
    </>
  );
};

export default SimplePageView;
